/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.7.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { getAuth0Token, getVectorBaseUrl, transformApiResult, transformRequestOptions } from './VectorClientHelpers';
export class VectorClientBase { 

    protected transformOptions(options: any) {
      return this.getToken().then(newToken => transformRequestOptions(newToken, options));
    }
  
  protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
    return transformApiResult(url, response, processor);
  }

  protected getBaseUrl(urlTemplate: string, defaultUrl: string | undefined): string {
    return getVectorBaseUrl(urlTemplate, defaultUrl);
  }

  private async getToken() {
    return getAuth0Token();
  }
}

export interface IVideosClient {
    /**
     * @return Success
     */
    videoPlaylistsAll(vaultId: number): Promise<VideoPlaylistApiModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    videoPlaylistsPOST(vaultId: number, body?: VideoPlaylistCreationRequest | undefined): Promise<VideoPlaylistApiModel>;
    /**
     * @return Success
     */
    videoPlaylistsGET(vaultId: number, playlistId: number): Promise<VideoPlaylistApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    videoPlaylistsPUT(vaultId: number, playlistId: number, body?: VideoPlaylistUpdateRequest | undefined): Promise<VideoPlaylistApiModel>;
    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    videoPlaylistsDELETE(vaultId: number, playlistId: number, shouldDelete?: boolean | undefined): Promise<VideoPlaylistApiModel>;
    /**
     * @param source (optional) 
     * @param sourceId (optional) 
     * @return Success
     */
    sourceSearch(vaultId: number, source?: string | undefined, sourceId?: string | undefined): Promise<VideoPlaylistApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    youtubeImport(vaultId: number, body?: YouTubePlaylistImportRequest | undefined): Promise<VideoPlaylistImportApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    videosPOST(vaultId: number, body?: VideoCreationRequest | undefined): Promise<VideoApiModel>;
    /**
     * @return Success
     */
    videosAll(vaultId: number, playlistId: number): Promise<VideoApiModel[]>;
    /**
     * @return Success
     */
    videosGET(vaultId: number, playlistId: number, videoId: number): Promise<VideoApiModel>;
    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    videosDELETE(vaultId: number, playlistId: number, videoId: number, shouldDelete?: boolean | undefined): Promise<VideoApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    videosPUT(vaultId: number, playlistId: number, videoId: number, body?: VideoUpdateRequest | undefined): Promise<VideoApiModel>;
}

export class VideosClient extends VectorClientBase implements IVideosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    videoPlaylistsAll(vaultId: number): Promise<VideoPlaylistApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/VideoPlaylists";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVideoPlaylistsAll(_response));
        });
    }

    protected processVideoPlaylistsAll(response: Response): Promise<VideoPlaylistApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VideoPlaylistApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoPlaylistApiModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    videoPlaylistsPOST(vaultId: number, body?: VideoPlaylistCreationRequest | undefined): Promise<VideoPlaylistApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/VideoPlaylists";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVideoPlaylistsPOST(_response));
        });
    }

    protected processVideoPlaylistsPOST(response: Response): Promise<VideoPlaylistApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoPlaylistApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoPlaylistApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    videoPlaylistsGET(vaultId: number, playlistId: number): Promise<VideoPlaylistApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/VideoPlaylists/{playlistId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (playlistId === undefined || playlistId === null)
            throw new Error("The parameter 'playlistId' must be defined.");
        url_ = url_.replace("{playlistId}", encodeURIComponent("" + playlistId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVideoPlaylistsGET(_response));
        });
    }

    protected processVideoPlaylistsGET(response: Response): Promise<VideoPlaylistApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoPlaylistApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoPlaylistApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    videoPlaylistsPUT(vaultId: number, playlistId: number, body?: VideoPlaylistUpdateRequest | undefined): Promise<VideoPlaylistApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/VideoPlaylists/{playlistId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (playlistId === undefined || playlistId === null)
            throw new Error("The parameter 'playlistId' must be defined.");
        url_ = url_.replace("{playlistId}", encodeURIComponent("" + playlistId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVideoPlaylistsPUT(_response));
        });
    }

    protected processVideoPlaylistsPUT(response: Response): Promise<VideoPlaylistApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoPlaylistApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoPlaylistApiModel>(<any>null);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    videoPlaylistsDELETE(vaultId: number, playlistId: number, shouldDelete?: boolean | undefined): Promise<VideoPlaylistApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/VideoPlaylists/{playlistId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (playlistId === undefined || playlistId === null)
            throw new Error("The parameter 'playlistId' must be defined.");
        url_ = url_.replace("{playlistId}", encodeURIComponent("" + playlistId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVideoPlaylistsDELETE(_response));
        });
    }

    protected processVideoPlaylistsDELETE(response: Response): Promise<VideoPlaylistApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoPlaylistApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoPlaylistApiModel>(<any>null);
    }

    /**
     * @param source (optional) 
     * @param sourceId (optional) 
     * @return Success
     */
    sourceSearch(vaultId: number, source?: string | undefined, sourceId?: string | undefined): Promise<VideoPlaylistApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/VideoPlaylists/source-search?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        if (sourceId === null)
            throw new Error("The parameter 'sourceId' cannot be null.");
        else if (sourceId !== undefined)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSourceSearch(_response));
        });
    }

    protected processSourceSearch(response: Response): Promise<VideoPlaylistApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoPlaylistApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoPlaylistApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    youtubeImport(vaultId: number, body?: YouTubePlaylistImportRequest | undefined): Promise<VideoPlaylistImportApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/VideoPlaylists/youtube-import";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processYoutubeImport(_response));
        });
    }

    protected processYoutubeImport(response: Response): Promise<VideoPlaylistImportApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoPlaylistImportApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoPlaylistImportApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    videosPOST(vaultId: number, body?: VideoCreationRequest | undefined): Promise<VideoApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Videos";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVideosPOST(_response));
        });
    }

    protected processVideosPOST(response: Response): Promise<VideoApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    videosAll(vaultId: number, playlistId: number): Promise<VideoApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/playlists/{playlistId}/Videos";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (playlistId === undefined || playlistId === null)
            throw new Error("The parameter 'playlistId' must be defined.");
        url_ = url_.replace("{playlistId}", encodeURIComponent("" + playlistId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVideosAll(_response));
        });
    }

    protected processVideosAll(response: Response): Promise<VideoApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VideoApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoApiModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    videosGET(vaultId: number, playlistId: number, videoId: number): Promise<VideoApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/playlists/{playlistId}/Videos/{videoId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (playlistId === undefined || playlistId === null)
            throw new Error("The parameter 'playlistId' must be defined.");
        url_ = url_.replace("{playlistId}", encodeURIComponent("" + playlistId));
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVideosGET(_response));
        });
    }

    protected processVideosGET(response: Response): Promise<VideoApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoApiModel>(<any>null);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    videosDELETE(vaultId: number, playlistId: number, videoId: number, shouldDelete?: boolean | undefined): Promise<VideoApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/playlists/{playlistId}/Videos/{videoId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (playlistId === undefined || playlistId === null)
            throw new Error("The parameter 'playlistId' must be defined.");
        url_ = url_.replace("{playlistId}", encodeURIComponent("" + playlistId));
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVideosDELETE(_response));
        });
    }

    protected processVideosDELETE(response: Response): Promise<VideoApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    videosPUT(vaultId: number, playlistId: number, videoId: number, body?: VideoUpdateRequest | undefined): Promise<VideoApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/playlists/{playlistId}/Videos/{videoId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (playlistId === undefined || playlistId === null)
            throw new Error("The parameter 'playlistId' must be defined.");
        url_ = url_.replace("{playlistId}", encodeURIComponent("" + playlistId));
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVideosPUT(_response));
        });
    }

    protected processVideosPUT(response: Response): Promise<VideoApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoApiModel>(<any>null);
    }
}

export class VideoApiModel implements IVideoApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    publisher?: string | undefined;
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
    source?: string | undefined;
    sourceId?: string | undefined;
    tags?: string[] | undefined;
    duration?: string | undefined;
    publishDate?: Date;

    constructor(data?: IVideoApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.publisher = _data["publisher"];
            this.url = _data["url"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.source = _data["source"];
            this.sourceId = _data["sourceId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.duration = _data["duration"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VideoApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new VideoApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["publisher"] = this.publisher;
        data["url"] = this.url;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["source"] = this.source;
        data["sourceId"] = this.sourceId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["duration"] = this.duration;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IVideoApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    publisher?: string | undefined;
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
    source?: string | undefined;
    sourceId?: string | undefined;
    tags?: string[] | undefined;
    duration?: string | undefined;
    publishDate?: Date;
}

export class VideoCreationAssignment implements IVideoCreationAssignment {
    parentId!: number;

    constructor(data?: IVideoCreationAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): VideoCreationAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new VideoCreationAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        return data; 
    }
}

export interface IVideoCreationAssignment {
    parentId: number;
}

export class VideoCreationRequest implements IVideoCreationRequest {
    assignments!: VideoCreationAssignment[];
    title!: string;
    tags!: string[];
    publishDate!: Date;
    isPublic!: boolean;
    source!: string;
    sourceId!: string;
    url?: string | undefined;
    description?: string | undefined;
    publisher?: string | undefined;
    thumbnailUrl?: string | undefined;
    duration?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: IVideoCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.assignments) {
                this.assignments = [];
                for (let i = 0; i < data.assignments.length; i++) {
                    let item = data.assignments[i];
                    this.assignments[i] = item && !(<any>item).toJSON ? new VideoCreationAssignment(item) : <VideoCreationAssignment>item;
                }
            }
        }
        if (!data) {
            this.assignments = [];
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(VideoCreationAssignment.fromJS(item));
            }
            this.title = _data["title"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.isPublic = _data["isPublic"];
            this.source = _data["source"];
            this.sourceId = _data["sourceId"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.publisher = _data["publisher"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.duration = _data["duration"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): VideoCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VideoCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        data["title"] = this.title;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["isPublic"] = this.isPublic;
        data["source"] = this.source;
        data["sourceId"] = this.sourceId;
        data["url"] = this.url;
        data["description"] = this.description;
        data["publisher"] = this.publisher;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["duration"] = this.duration;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface IVideoCreationRequest {
    assignments: IVideoCreationAssignment[];
    title: string;
    tags: string[];
    publishDate: Date;
    isPublic: boolean;
    source: string;
    sourceId: string;
    url?: string | undefined;
    description?: string | undefined;
    publisher?: string | undefined;
    thumbnailUrl?: string | undefined;
    duration?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;
}

export class VideoPlaylistApiModel implements IVideoPlaylistApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    tags?: string[] | undefined;
    videoCount?: number;
    videos?: VideoApiModel[] | undefined;
    sourceId?: string | undefined;
    source?: string | undefined;

    constructor(data?: IVideoPlaylistApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.videos) {
                this.videos = [];
                for (let i = 0; i < data.videos.length; i++) {
                    let item = data.videos[i];
                    this.videos[i] = item && !(<any>item).toJSON ? new VideoApiModel(item) : <VideoApiModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.videoCount = _data["videoCount"];
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(VideoApiModel.fromJS(item));
            }
            this.sourceId = _data["sourceId"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): VideoPlaylistApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new VideoPlaylistApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["videoCount"] = this.videoCount;
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        data["sourceId"] = this.sourceId;
        data["source"] = this.source;
        return data; 
    }
}

export interface IVideoPlaylistApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    tags?: string[] | undefined;
    videoCount?: number;
    videos?: IVideoApiModel[] | undefined;
    sourceId?: string | undefined;
    source?: string | undefined;
}

export class VideoPlaylistCreationRequest implements IVideoPlaylistCreationRequest {
    title!: string;
    tags!: string[];
    description?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;
    sourceId?: string | undefined;
    source?: string | undefined;

    constructor(data?: IVideoPlaylistCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.description = _data["description"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
            this.sourceId = _data["sourceId"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): VideoPlaylistCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VideoPlaylistCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["description"] = this.description;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        data["sourceId"] = this.sourceId;
        data["source"] = this.source;
        return data; 
    }
}

export interface IVideoPlaylistCreationRequest {
    title: string;
    tags: string[];
    description?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;
    sourceId?: string | undefined;
    source?: string | undefined;
}

export class VideoPlaylistImportApiModel implements IVideoPlaylistImportApiModel {
    playlist?: VideoPlaylistApiModel;
    failedVideos?: string[] | undefined;

    constructor(data?: IVideoPlaylistImportApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playlist = data.playlist && !(<any>data.playlist).toJSON ? new VideoPlaylistApiModel(data.playlist) : <VideoPlaylistApiModel>this.playlist; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playlist = _data["playlist"] ? VideoPlaylistApiModel.fromJS(_data["playlist"]) : <any>undefined;
            if (Array.isArray(_data["failedVideos"])) {
                this.failedVideos = [] as any;
                for (let item of _data["failedVideos"])
                    this.failedVideos!.push(item);
            }
        }
    }

    static fromJS(data: any): VideoPlaylistImportApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new VideoPlaylistImportApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playlist"] = this.playlist ? this.playlist.toJSON() : <any>undefined;
        if (Array.isArray(this.failedVideos)) {
            data["failedVideos"] = [];
            for (let item of this.failedVideos)
                data["failedVideos"].push(item);
        }
        return data; 
    }
}

export interface IVideoPlaylistImportApiModel {
    playlist?: IVideoPlaylistApiModel;
    failedVideos?: string[] | undefined;
}

export class VideoPlaylistUpdateRequest implements IVideoPlaylistUpdateRequest {
    newParentId!: number;
    title!: string;
    description!: string;
    tags!: string[];
    legacyKnowledgebaseId?: string | undefined;
    sourceId?: string | undefined;
    source?: string | undefined;

    constructor(data?: IVideoPlaylistUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
            this.sourceId = _data["sourceId"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): VideoPlaylistUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VideoPlaylistUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        data["sourceId"] = this.sourceId;
        data["source"] = this.source;
        return data; 
    }
}

export interface IVideoPlaylistUpdateRequest {
    newParentId: number;
    title: string;
    description: string;
    tags: string[];
    legacyKnowledgebaseId?: string | undefined;
    sourceId?: string | undefined;
    source?: string | undefined;
}

export class VideoUpdateRequest implements IVideoUpdateRequest {
    assignments!: VideoCreationAssignment[];
    title!: string;
    tags!: string[];
    publishDate!: Date;
    isPublic!: boolean;
    source!: string;
    sourceId!: string;
    modifiedOn!: Date;
    description?: string | undefined;
    publisher?: string | undefined;
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
    duration?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: IVideoUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.assignments) {
                this.assignments = [];
                for (let i = 0; i < data.assignments.length; i++) {
                    let item = data.assignments[i];
                    this.assignments[i] = item && !(<any>item).toJSON ? new VideoCreationAssignment(item) : <VideoCreationAssignment>item;
                }
            }
        }
        if (!data) {
            this.assignments = [];
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(VideoCreationAssignment.fromJS(item));
            }
            this.title = _data["title"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.isPublic = _data["isPublic"];
            this.source = _data["source"];
            this.sourceId = _data["sourceId"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.publisher = _data["publisher"];
            this.url = _data["url"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.duration = _data["duration"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): VideoUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VideoUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        data["title"] = this.title;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["isPublic"] = this.isPublic;
        data["source"] = this.source;
        data["sourceId"] = this.sourceId;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["publisher"] = this.publisher;
        data["url"] = this.url;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["duration"] = this.duration;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface IVideoUpdateRequest {
    assignments: IVideoCreationAssignment[];
    title: string;
    tags: string[];
    publishDate: Date;
    isPublic: boolean;
    source: string;
    sourceId: string;
    modifiedOn: Date;
    description?: string | undefined;
    publisher?: string | undefined;
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
    duration?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;
}

export class YouTubePlaylistImportRequest implements IYouTubePlaylistImportRequest {
    sourceId!: string;

    constructor(data?: IYouTubePlaylistImportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
        }
    }

    static fromJS(data: any): YouTubePlaylistImportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new YouTubePlaylistImportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        return data; 
    }
}

export interface IYouTubePlaylistImportRequest {
    sourceId: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}